export const loading = {
	methods: {
		changeLoading: function (status) {
			this.$store.dispatch("setLoading", status);
		}
	}
}